<template>
  <div>
    <el-tabs class="tab tabCon" v-model="activeName" type="card" >
      <el-tab-pane label="全部" name="first">
        <div class="conBor">
          <el-table :data="seatData" stripe style="width: 100%">
            <el-table-column fixed prop="code" label="编号" align='center'></el-table-column>
            <el-table-column prop="name" label="教室" align='center'></el-table-column>
            <el-table-column label="科目级别" align='center'>
              <template slot-scope="scope">
                <div>
                  <div>
                  <span >{{scope.row.subjectName}}</span>&nbsp;&nbsp;<span >{{scope.row.subjectLevelName}}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="time" label="时间" align='center'></el-table-column>
            <el-table-column prop="placeName" label="考点" align='center'></el-table-column>
            <el-table-column prop="count" label="操作" align='center'>
              <template slot-scope="scope">
                <div>
                  <el-button type="text" @click='toSeat(scope.row)'>选座位</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- <div class="block">
          <el-pagination
            @current-change="pageChange"
            :page-size="params.pageSize"
            layout="prev, pager, next, jumper"  
            :total="tutorialData.totalCount"
          ></el-pagination>
        </div> -->
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getTimeChange } from '@/utils/filter'
export default {
  data() {
    return {
      activeName: "first",
      seatData: [],
      signId:''
      // params: {
      //   pageNo: 1,
      //   pageSize: 10,
      //   typeId: null,
      //   status: 1
      // }
    };
  },
  created() {
    console.log(localStorage.getItem("token"));
    this.signId= sessionStorage.getItem('signId')
    this.seatList()
    console.log(this.signId)
    // console.log(this.$route.query.signId)
  },
  methods: {
    seatList(){
      let me = this 
      console.log(1111111111,this.signId)
      window.Global.get("/choose/classRooms", {
        // signId:'12ef4ac54f044c15a8c8b2eb212000e0'
        signId:this.signId
      }, rs => {
        console.log(rs.data.result);
        if (rs.data.status == 200) {
          me.seatData = rs.data.result.map((item)=>{
            item.time = getTimeChange(item.time);
            return {
              ...item   //结构赋值
            }
          })
          console.log(22222222222,me.seatData)
        } else {
        }
      });
    },
    toSeat(detall){
      console.log(detall)
      sessionStorage.setItem('detall',JSON.stringify(detall))
      // this.$router.push({path:'/indexSelectSeat?id='+detall.id+'&count='+detall.count+'&address='+detall.address+'&time='+detall.time+'&name='+detall.name+'&subjectName='+detall.subjectName+'&subjectLevelName='+detall.subjectLevelName})
      this.$router.push({name:"indexSelectSeat"})
    }
  }
};
</script>   

<style lang="less">
@import "../../static/less/tutorial.less";
</style>



// WEBPACK FOOTER //
// src/components/seat.vue